const GenderSelection = ({ formData, handleChange, nextStep, prevStep, errors }) => {
  return (
    <div className="form-container">
      <h2>Gender Selection</h2>
      <form>
        <div className={`radio-group ${errors.gender ? 'error' : ''}`}>
          <label>
            <input
              type="radio"
              name="gender"
              value="Male"
              checked={formData.gender === 'Male'}
              onChange={handleChange}
              required
            />
            Male
          </label>
          <label>
            <input
              type="radio"
              name="gender"
              value="Female"
              checked={formData.gender === 'Female'}
              onChange={handleChange}
            />
            Female
          </label>
          <label>
            <input
              type="radio"
              name="gender"
              value="Other"
              checked={formData.gender === 'Other'}
              onChange={handleChange}
            />
            Other
          </label>
          {errors.gender && <div className="error-message">{errors.gender}</div>}
        </div>

        <div className="button-group">
          <button type="button" onClick={prevStep}>Back</button>
          <button 
            type="button" 
            onClick={nextStep}
            disabled={!formData.gender}
          >
            Next
          </button>
        </div>
      </form>
    </div>
  );
};

export default GenderSelection;